<div >
    <div class="container pt-2 pb-2 bg-w i-box-shadow">
        <router-outlet></router-outlet>
    </div>
</div>
